export default {
    btnClass: 'bg-gradient-to-r from-blue-500 to-green-500 dark:bg-indigo-700',
    cardClass: 'bg-cyan-700 bg-opacity-10 dark:bg-white dark:bg-opacity-10 '
}